import gql from 'graphql-tag'

export const GET_ZONES = gql`
  query Zones($filter: GetZonesInput) {
    zones(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      zones {
        data {
          zoneId
          code
          name
          description
          geometry
          landArea
          vehicleId
          vehicle {
            licensePlate
            chassisNumber
          }
          startTrip
          endTrip
          province
          city
          startWorkTime
          endWorkTime
          isActive
          createdOn
          createdBy {
            fullname
          }
          updatedOn
          updatedBy {
            fullname
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const CREATE_LAND_MEASUREMENT = gql`
  mutation CreateZone($input: CreateZonesInput!) {
    createZone(input: $input) {
      isSuccessful
      message
      status
      zone {
        zoneId
        code
        name
        description
        geometry
        vehicleId
        startTrip
        endTrip
        landArea
        province
        city
        startWorkTime
        endWorkTime
      }
    }
  }
`

export const GET_ZONE = gql`
  query Zone($filter: GetZoneInput) {
    zone(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      zone {
        zoneId
        code
        name
        description
        geometry
        landArea
        vehicleId
        vehicle {
          id
          licensePlate
          chassisNumber
        }
        startTrip
        endTrip
        province
        city
        startWorkTime
        endWorkTime
        isActive
        createdOn
        createdBy {
          fullname
        }
        updatedOn
        updatedBy {
          fullname
        }
      }
    }
  }
`

export const UPDATE_LAND_MEASUREMENT = gql`
  mutation UpdateZone($input: UpdateZoneInput!) {
    updateZone(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      zone {
        zoneId
        code
        name
        description
        geometry
        vehicleId
        startTrip
        endTrip
        landArea
        province
        city
        startWorkTime
        endWorkTime
      }
    }
  }
`

export const DELETE_LAND_MEASUREMENT = gql`
  mutation DeleteZone($input: DeleteZonesInput!) {
    deleteZone(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteZone {
        zoneId
        code
        name
        description
        geometry
        vehicleId
        startTrip
        endTrip
        landArea
        province
        city
        startWorkTime
        endWorkTime
      }
    }
  }
`

export const REPORT_LAND_MEASUREMENT = gql`
  query ZonesReport($filter: GetZonesReportInput) {
    zonesReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      getZonesReport {
        report
      }
    }
  }
`
